import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'Customers taps "share" in the action toolbar',
  name: 'share_clicked',
  params: [
    {
      description: 'Location of the event',
      name: 'location',
      required: true,
      type: 'string',
    },
  ],
};

export default META;
